import root from '../../index';
import { isStorageAvailable } from '../../utils';
import { setCustomData } from '../../analytics';
import ecredContact from '../../partials/ecred-contact/ecred-contact';

import './index.scss';

const STORAGE_AVAILABLE = isStorageAvailable();

function main() {
  root(true);
  setCustomData('canais-de-atendimento', 'conteudo interno');
}

main();



// WEBPACK FOOTER //
// ./src/pages/service_channels/index.js